Shopware.Component.extend('sw-cms-el-acris-blog-content', 'sw-cms-el-text', () => import('./component'));
Shopware.Component.extend('sw-cms-el-config-acris-blog-content', 'sw-cms-el-config-text', () => import('./config'));
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-content',
    label: 'acris-blog.elements.blogContent.label',
    component: 'sw-cms-el-acris-blog-content',
    configComponent: 'sw-cms-el-config-acris-blog-content',
    previewComponent: 'sw-cms-el-preview-acris-blog-content',
    defaultConfig: {
        content: {
            source: 'static',
            value: '<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>',
        },
        verticalAlign: {
            source: 'static',
            value: null,
        }
    }
});